const unionByKey = (array1, array2, key) => {
    const mergedArray = [...array1, ...array2];
    return [...new Map(mergedArray.map((item) => [item[key], item])).values()];
};

export { unionByKey };
